"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _PageContext = _interopRequireDefault(require("../context/PageContext"));
var _WebProfileContext = _interopRequireDefault(require("../context/WebProfileContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useSystemLinks = () => {
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const [profileData] = (0, _react.useContext)(_WebProfileContext.default);
  const [links, setLinks] = (0, _react.useState)([]);
  const {
    lang
  } = pageData || {};
  const {
    customLinks
  } = profileData || {};
  (0, _react.useEffect)(() => {
    if (!customLinks || !lang) return;
    setLinks(customLinks);
  }, [customLinks, lang]);
  const resolveObject = (0, _react.useCallback)(identifier => {
    var _links$find;
    return links === null || links === void 0 || (_links$find = links.find(item => item.identifier === identifier)) === null || _links$find === void 0 ? void 0 : _links$find.url;
  }, [links]);
  return function (identifier) {
    try {
      return resolveObject(identifier);
    } catch (error) {
      return "";
    }
  };
};
var _default = exports.default = useSystemLinks;